import { render, staticRenderFns } from "./Aspectos.vue?vue&type=template&id=10c89d3e&"
import script from "./Aspectos.vue?vue&type=script&lang=js&"
export * from "./Aspectos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports